module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vendo5-8d4d9fa846a66a58a9377ca9decfcece.jpg";